import { noop } from 'lodash';
import { Dispatch, createContext, SetStateAction } from 'react';

export type Skipped = Record<string, boolean>;

export const SkippedContext = createContext<
  [Skipped, Dispatch<SetStateAction<Record<string, boolean>>>]
>([{}, noop]);
